import '../public-path';
import '../vendor';
import '../polyfills';
import '../utils/focus-ring';
import { load } from '@shopify/theme-sections';
import quicklink from 'quicklink';
import 'keen-slider/keen-slider.min.css';
import '../../styles/theme.pcss';
import '../sections/header';
import { Application } from '../modules/module/application';
import { MediaBreakpoints } from '../modules/static/media-breakpoints';
import { RichText } from '../modules/static/rich-text';
import { externalLinks } from '../utils';
load(['header']); // This can clear the cart on the cart page because of the remove links, don't use this on that

if (window.location.pathname !== '/cart' && !window.theme.isDevTheme) {
  window.addEventListener('load', () => {
    quicklink({
      // Can error on mailto links when on https
      ignores: [uri => uri.includes('mailto:'), uri => uri.includes('/account'), uri => uri.includes('/cart')]
    });
  });
}

window.BAO.application = Application.start();
window.BAO.mediaBreakpoints = new MediaBreakpoints();
document.addEventListener('DOMContentLoaded', () => {
  externalLinks();
  RichText.start(); // If the device is iOS add a class to the body so we can do specific CSS for it

  if (!!navigator.platform && /iPad|iPhone|iPod/.test(navigator.platform)) {
    const body = document.body || document.documentElement;
    body.classList.add('is-iOS');
  }
});